import { render, staticRenderFns } from "./fileCollection.vue?vue&type=template&id=480f3e46&scoped=true&"
import script from "./fileCollection.vue?vue&type=script&lang=jsx&"
export * from "./fileCollection.vue?vue&type=script&lang=jsx&"
import style0 from "./fileCollection.vue?vue&type=style&index=0&id=480f3e46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480f3e46",
  null
  
)

export default component.exports